import React from "react";
import Header from './header';
import Footer from './footer';
import Cards from './cards';
import './index.scss';

export default class SectionFrame extends React.Component {
    static defaultProps = {
        columns: 3,
        header: {
            icon: null,
            title: null,
            description: null,
        },
        footer: {
            actions: [],
            align: 'right',
        }
    }
    render() {
        const className = ('pubhub-section-frame ' + (this.props.className || '')).trim();
        const header = this.renderHeader();
        const body = this.renderBody();
        const footer = this.renderFooter();

        return (
            <div id={this.props.id} className={className} style={this.props.style}>
                {header}
                {body}
                {footer}
            </div>
        );
    }
    renderHeader() {
        const { header } = this.props;
        const hasHeader = header ? (header.icon || header.title || header.description) : false;

        if (!hasHeader) null;

        return (
            <Header {...header} />
        );
    }
    renderBody() {
        const body = Array.isArray(this.props.children) ? <Cards columns={this.props.columns}>{this.props.children}</Cards> : this.props.children;
        return (
            <div className='body'>
                {body}
            </div>
        );
    }
    renderFooter() {
        if(!this.props.footer || (!this.props.footer.actions && !this.props.beforeActions && !this.props.afterActions)) return null;

        return (
            <Footer {...this.props.footer} />
        )
    }
}